module.exports = __webpack_public_path__ + "img/boston.5ad2d3d9.jpg";